<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-tabs v-model="activeTab" @tab-click="tabHandleClick">
            <el-tab-pane label="基本信息" name="baseinfo">
              <el-form
                v-loading="loading"
                :model="adminForm"
                :rules="rules"
                ref="adminForm"
                label-width="120px"
                class="adminForm">
                <el-form-item label="用户名" prop="username" v-if="account">
                  <el-input v-model="adminForm.username" clearable @change="syncNames"/>
                  <ul class="switches">
                    <li>
                      <el-switch
                        v-model="adminForm.testkey"
                        active-text="开启"
                        inactive-text="关闭"
                        active-color="#13ce66"
                        inactive-color="#ff4949"/>
                      测试账户
                    </li>
                    <li>
                      <el-switch
                        v-model="adminForm.school_login"
                        active-text="允许"
                        inactive-text="禁止"
                        active-color="#13ce66"
                        inactive-color="#ff4949"/>
                      登录院校库
                    </li>
                    <li>
                      <el-switch
                        v-model="adminForm.uk_school_login"
                        active-text="允许"
                        inactive-text="禁止"
                        active-color="#13ce66"
                        inactive-color="#ff4949"/>
                      登录院校库-美国VIP
                    </li>
                  </ul>
                </el-form-item>
                <el-form-item
                  label="论坛ID"
                  v-if="account">
                  <el-input
                    v-model="adminForm.touserid"
                    readonly/>
                </el-form-item>
                <el-form-item
                  label="电话"
                  v-if="account">
                  <el-input
                    type="tel"
                    v-model="adminForm.tel"/>
                  <span v-if="account">请填写有效号码，用于登录APP</span>
                </el-form-item>
                <el-form-item label="用户角色" prop="role_id" v-if="account">
                  <el-select
                    v-model="adminForm.role_id"
                    placeholder="搜索角色"
                    filterable
                    clearable>
                    <el-option
                      v-for="role in rolesData"
                      :label="role.name"
                      :value="role.rolename"
                      :key="role.rolename"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="扩展角色" prop="auth_role_ids" v-if="account">
                  <el-select
                    v-model="adminForm.auth_role_ids"
                    placeholder="扩展角色"
                    multiple
                    filterable
                    clearable>
                    <el-option
                      v-for="role in rolesData"
                      :label="role.name"
                      :value="role.rolename"
                      :key="role.rolename"/>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="部门"
                  prop="department"
                  v-if="account">
                  <el-select
                    v-model="adminForm.department"
                    placeholder="选择部门"
                    filterable
                    clearable>
                    <el-option
                      :label="depart.name"
                      :value="depart.id"
                      v-for="depart in deptListData"
                      :key="depart.id"/>
                  </el-select>
                  <span style="margin-left:20px;">
                    <el-checkbox
                      v-model="adminForm.is_depthead"
                      :true-label="1"
                      :false-label="0" /> 部门主管（一般用于市场部门、考培咨询，与钉钉部门层级类似）
                  </span>
                </el-form-item>
                <el-form-item
                  label="特有功能"
                  v-if="account">
                  <el-switch
                    v-model="adminForm.powers"
                    active-text="开启"
                    inactive-text="关闭"
                    active-color="#13ce66"
                    inactive-color="#ff4949"/>
                  回访（客户支持组）
                </el-form-item>
                <el-form-item label="真实姓名" prop="truename" v-if="account">
                  <el-input v-model="adminForm.truename"/>
                </el-form-item>
                <el-form-item label="昵称">
                  <el-input v-model="adminForm.nickname"/>
                </el-form-item>
                <el-form-item label="微信">
                  <el-input v-model="adminForm.weixin"/>
                </el-form-item>
                <el-form-item label="QQ">
                  <el-input v-model="adminForm.qq"/>
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input v-model="adminForm.telephone"/>
                </el-form-item>
                <el-form-item label="企业QQ">
                  <el-input v-if="adminForm.biz_qq_openid" v-model="adminForm.biz_qq" readonly="readonly" />
                  <el-button v-else type="primary" icon="el-icon-service" @click="bindBizQQ">
                    绑定企业QQ
                  </el-button>
                </el-form-item>
                <el-form-item label="头像" v-if="!account || adminId">
                  <jm-upload
                    class="uploadFile"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :action="userUploadFile"
                    :data="{
                      userid: adminId,
                      type: 'touxiang'
                    }"
                    :show-file-list="false"
                    :on-success="setAvatar"
                    auto-upload
                  >
                    <img
                      v-if="adminForm.touxiang"
                      :src="`${$jiemo.imghome}/Upload/teacher/${adminForm.touxiang}`"
                      class="avatar">
                    <i v-else class="el-icon-plus"/>
                    <div slot="tip" class="el-upload__tip">只能上传不超过500kb的图片</div>
                  </jm-upload>
                </el-form-item>
                <el-form-item label="微信头像" v-if="!account || adminId">
                  <jm-upload
                    class="uploadFile"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :action="userUploadFile"
                    :data="{
                      userid: adminId,
                      type: 'wechat_portrait'
                    }"
                    :show-file-list="false"
                    :on-success="setWxPortrait"
                    auto-upload
                  >
                    <img
                      v-if="adminForm.wechat_portrait"
                      :src="`${$jiemo.imghome}/Upload/teacher/${adminForm.wechat_portrait}`"
                      class="avatar">
                    <i v-else class="el-icon-plus"/>
                    <div slot="tip" class="el-upload__tip">只能上传不超过500kb的图片</div>
                  </jm-upload>
                </el-form-item>
                <el-form-item
                  label="微信二维码"
                  v-if="!account || adminId">
                  <jm-upload
                    class="uploadFile"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :action="userUploadFile"
                    :data="{
                      userid: adminId,
                      type: 'weixin_ma'
                    }"
                    :show-file-list="false"
                    :on-success="setQr"
                    auto-upload
                  >
                    <img
                      v-if="adminForm.weixin_ma"
                      :src="`${$jiemo.imghome}/Upload/teacher/${adminForm.weixin_ma}`"
                      class="avatar">
                    <i v-else class="el-icon-plus"/>
                    <div slot="tip" class="el-upload__tip">只能上传不超过500kb的图片</div>
                  </jm-upload>
                </el-form-item>
                <el-form-item label="报名表通用二维码" v-if="interviewWxCode" v-permission="[20, 54]">
                  <img
                    style="width: 200px;"
                    :src="interviewWxCode"
                    class="avatar">
                </el-form-item>
                <el-form-item label="擅长领域">
                  <el-input
                    type="textarea"
                    v-model="adminForm.zixundandang"/>
                </el-form-item>
                <el-form-item label="专业背景">
                  <el-input
                    type="textarea"
                    v-model="adminForm.wenandandang"/>
                </el-form-item>
                <el-form-item label="我的标签">
                  <el-checkbox-group v-model="adminForm.my_style">
                    <el-checkbox
                      :label="flag"
                      name="flags"
                      v-for="flag in flagData"
                      :key="flag"/>
                  </el-checkbox-group>
                  <div class="createFlag">
                    <el-input
                      v-model="newFlag"
                      size="small"
                      placeholder="添加多个标签用空格或逗号隔开"/>
                    <el-button
                      type="primary"
                      size="small"
                      @click="createFlag"
                      title="添加标签"
                      icon="el-icon-plus"/>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="success"
                    @click="sendForm">{{ btnSubTxt }}</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="办理国家" v-if="adminId" name="country">
              <div class="power-left-wrap"></div>
              <div class="power-right-wrap"></div>
            </el-tab-pane>
            <el-tab-pane label="推广渠道" v-if="adminId" name="channel">
              <div class="power-left-wrap"></div>
              <div class="power-right-wrap"></div>
            </el-tab-pane>
            <el-tab-pane label="钉钉账号" v-if="adminId" name="dingtalk">
              <div class="power-left-wrap"></div>
              <div class="power-right-wrap"></div>
            </el-tab-pane>
            <el-tab-pane label="企业微信" v-if="adminId" name="wework">
              <div class="power-left-wrap"></div>
              <div class="power-right-wrap"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { mapState } from 'vuex';

const rules = {
  username: [
    {
      required: true, message: '请输入用户名', trigger: 'blur'
    }
  ],
  role_id: [
    {
      required: true, message: '请选择角色', trigger: 'change', type: 'number'
    }
  ],
  department: [
    {
      required: true, message: '请选择部门', trigger: 'change', type: 'number'
    }
  ],
  truename: [
    {
      required: true, message: '请输入真实姓名', trigger: 'blur'
    }
  ],
};

export default {
  components: { jmToolbar, jmTableList },
  data() {
    return {
      refresh: false,
      loading: false,
      activeTab: 'baseinfo',
      btnSubTxt: '创建用户',
      account: true,
      adminForm: {
        app_touxiang: '',
        department: null,
        is_depthead: 0, // 是否为部门主管
        touserid: null,
        my_style: [],
        nickname: '',
        powers: false,
        qq: '',
        role_id: null,
        auth_role_ids: [],
        school_login: true,
        uk_school_login: true,
        tel: '',
        telephone: '',
        testkey: false,
        touxiang: '',
        truename: '',
        userid: null,
        username: '',
        weixin: '',
        weixin_ma: '',
        wechat_portrait: '',
        wenandandang: '',
        zixundandang: '',
        biz_qq: '',
        biz_qq_openid: ''
      },
      rolesData: '',
      deptListData: [],
      flagData: ['有耐心', '专业择校', '海归', '年轻有活力', ' 待人热情', '诚信度高', '家长评价好', '认真细致', '超有耐心', '可爱的', '专业留学申请', '文案功底强', '低调深沉的', '外语达人'],
      newFlag: '',
      userUploadFile: '/newfib.php/index/power/userUploadFile',
      rules,
      interviewWxCode: '',
    };
  },
  created() {
    this.fetchInterviewFormWxCode();
  },
  mounted() {
    this.routeName = this.$route.matched[0].name;
    this.fetchData();
    this.btnSubTxt = (this.adminId || this.routeName === 'account') ? '确认修改' : '创建用户';
  },
  computed: {
    adminId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return null;
    },
    ...mapState([
      'userinfo',
    ]),
  },
  methods: {
    syncNames () {
      if (!this.adminForm.adminId) {
        if (!this.adminForm.truename) this.adminForm.truename = this.adminForm.username;
        if (!this.adminForm.nickname) this.adminForm.nickname = this.adminForm.username;
      }
    },
    fetchMenu () {
      this.refresh = true;
    },
    fetchData() {
      let url = '/index/power/userDetail';
      let rtn = this.routeName;
      let aid = this.adminId;
      if (rtn === 'account' || (rtn === 'adminEdit' && aid)) {
        if (rtn === 'account') {
          this.account = false;
        }
        if (aid) {
          url += `?userid=${aid}`;
        }
        this.$http._get({ url })
          .then(({ data }) => {
            let curData = data;
            this.flagData = [...new Set(this.flagData.concat(curData.my_style))];
            this.adminForm = Object.assign({}, curData);
          });
      }
      this.$http._get({
        url: '/index/power/userInterface'
      })
        .then(({ data }) => {
          this.rolesData = data.rolers;
          this.deptListData = data.department;
        });
    },
    setAvatar(res) {
      this.setFile('touxiang', res);
    },
    setAvatarForApp(res) {
      this.setFile('app_touxiang', res);
    },
    setQr(res) {
      this.setFile('weixin_ma', res);
    },
    setWxPortrait(res) {
      this.setFile('wechat_portrait', res);
    },
    setFile(field, file) {
      this.adminForm[field] = file.data.file_name;
    },
    createFlag() {
      if (!this.newFlag) {
        return false;
      }
      let newFlag = [...new Set(this.newFlag.split(/\s+|,|，/))];
      newFlag.forEach((flag) => {
        if (!flag) {
          return true;
        }
        let has = this.flagData.findIndex(item => item === flag);
        if (has !== -1) {
          this.$message({ message: '标签有重复', type: 'warning' });
          return true;
        }
        this.flagData.push(flag);
        this.adminForm.my_style.push(flag);
      });
      this.newFlag = '';
    },
    sendForm() {
      let ruleData = Object.assign({}, this.adminForm);
      let flag = false;
      this.$refs.adminForm.validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          window.scrollTo(0, 0);
          return false;
        }
      });
      if (!flag) {
        return false;
      }

      this.loading = true;
      this.$http._post({
        url: '/index/power/userAdd',
        data: ruleData
      })
        .then((res) => {
          this.$message({ message: res.msg, type: res.result !== 0 ? 'error' : 'success' });
          this.loading = false;
          if (this.routeName === 'adminEdit' && !this.adminId) {
            this.$router.push({ name: 'admin' });
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    bindBizQQ() {
      if (window.location.hostname === 'fib.jiemo.net') {
        let qqBizUrl = 'https://openapi.b.qq.com/oauth2/authorize?response_type=code&app_id=202002342&redirect_uri=https%253A%252F%252Fwww.jiemo.net%252FApp%252FBizQQ%252FuserCallback&state=';
        let state = ['FibBindBizQQ', this.adminForm.userid, (new Date()).valueOf()].join('-');

        window.open(qqBizUrl + state);
      } else {
        this.$message({ message: '该绑定功能仅对正式服有效！测试服请直接修改数据库。', type: 'error' });
      }
    },
    // 切换tab
    tabHandleClick(tab) {
      if (tab.name !== 'baseinfo') {
        this.$router.push({ name: 'adminExtend', params: { id: this.adminId }, hash: `#${tab.name}` });
      }
    },
    async fetchInterviewFormWxCode() {
      const { data } = await this.$http._post({
        url: '/index/power/getInterviewNormalWxCode',
      });
      // console.log(data);
      this.interviewWxCode = data;
    },
  }
};
</script>

<style scoped>
.adminForm .el-switch {
  position: relative;
  bottom: 1px;
  margin-right: .125em;
}
.adminForm .switches,
.adminForm .switches li {
  display: inline-block;
}
.adminForm .switches li {
  padding-right: 2em;
}
.adminForm .el-input{
  width: 200px;
  margin-right: .75em;
}
.adminForm .el-textarea {
  width: 36%;
  min-width: 400px;
  margin-right: .75em;
}
.adminForm .createFlag {
  padding-top: 1em;
}
.adminForm .createFlag button {
  margin-right: 1em;
}
.adminForm .avatar {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
.adminForm .uploadFile .el-upload.el-upload--picture-card {
  width: 100px !important;
  height: 100px !important;
  line-height: 100px !important;
}
.power-left-wrap{
  float: left;
  padding-left: 15px;
  width: 290px;
  min-height: 500px;
}
.power-right-wrap{
  margin-left: 290px;
  padding-left: 10px;
  min-height: 500px;
  border-left: 1px solid #f0f0f0;
}
</style>
